// Core services & configuration
export { AgentKitService } from "./core/agent-kit.service";
export { provideAgentKit, injectAgentKitConfig, AGENT_KIT_CONFIG } from "./core/agent-kit-config";
export type { AgentKitConfig } from "./core/agent-kit-config";
export { AgentFactory, AgentStore, injectAgentStore } from "./core/agent";
export { connectAgentContext } from "./core/agent-context";
export type { ConnectAgentContextConfig } from "./core/agent-context";
export { provideAiChatLabels, injectChatLabels, AI_CHAT_LABELS, AI_CHAT_DEFAULT_LABELS } from "./core/chat-labels";
export type { AiChatLabels } from "./core/chat-labels";
export { ACHAT_VIEW_CONFIG, injectAchatViewConfig } from "./core/achat-view-config";
export type { AchatViewConfig } from "./core/achat-view-config";
export { ChatState, injectChatState } from "./core/chat-state";
export { ChatContextService } from "./core/chat-context.service";
export { registerRenderToolCall, registerFrontendTool } from "./core/tools";
export type { AngularToolCall, ToolRenderer, ClientTool, RenderToolCallConfig, FrontendToolConfig } from "./core/tools";

// Directives
export { AgentContextDirective } from "./directives/agent-context.directive";
export { StickToBottom } from "./directives/stick-to-bottom";
export { CopilotTooltip } from "./directives/tooltip";

// Chat components - public API
export { AgentChat } from "./components/ai-chat";
export { AgentChatView } from "./components/ai-chat-view";
export { AgentChatMessageView } from "./components/ai-chat-message-view";
export { AgentChatMessageViewCursor } from "./components/ai-chat-message-view-cursor";
export { AgentChatInput } from "./components/ai-chat-input";
export { AgentChatAssistantMessage } from "./components/ai-chat-assistant-message";
export { AgentChatAssistantMessageRenderer } from "./components/ai-chat-assistant-message-renderer";
export { AgentChatAssistantMessageToolbar } from "./components/ai-chat-assistant-message-toolbar";
export {
  AgentChatAssistantMessageCopyButton,
  AgentChatAssistantMessageThumbsUpButton,
  AgentChatAssistantMessageThumbsDownButton,
} from "./components/ai-chat-assistant-message-buttons";
export { AgentChatToolCallsView } from "./components/ai-chat-tool-calls-view";
export { AgentChatUserMessage } from "./components/ai-chat-user-message";
export { AgentChatViewScrollView } from "./components/ai-chat-view-scroll-view";
export { AgentChatViewInputContainer } from "./components/ai-chat-view-input-container";
export { AgentChatViewHandlers } from "./components/ai-chat-view-handlers";
export { AgentChatInputDefaults } from "./components/ai-chat-input-defaults";

// Types
export type {
  AiChatInputMode,
  ToolsMenuItem,
  AudioRecorderState,
  AudioRecorderError,
} from "./components/ai-chat-input.types";
export type {
  AgentChatAssistantMessageOnThumbsUpProps,
  AgentChatAssistantMessageOnThumbsDownProps,
  AgentChatAssistantMessageOnReadAloudProps,
  AgentChatAssistantMessageOnRegenerateProps,
} from "./components/ai-chat-assistant-message.types";
export type {
  AgentChatUserMessageOnEditMessageProps,
  AgentChatUserMessageOnSwitchToBranchProps,
} from "./components/ai-chat-user-message.types";
